import { SchoolType } from 'types';
import { QuestionTypeData } from './type';
import { schoolTypeCodeOption } from 'constants/optionCommon';

//Cây thư mục của danh mục loại câu hỏi chỉ dùng 2 cấp
const buildTreeData_QuestionType = (list: QuestionTypeData[]) => {
  const filterLevel0 = list
    .filter((i) => !i.parentId || i.parentId === '00000000-0000-0000-0000-000000000000')
    .sort((a: QuestionTypeData, b: QuestionTypeData) => Number(a.sortOrder ?? 0) - Number(b.sortOrder ?? 0));
  const treeData = filterLevel0.map((item) => {
    const children = list
      .filter((i) => i.parentId === item.id)
      .map((i) => ({
        key: i.id,
        title: i.questionTypeName,
        children: [],
        level: 2,
        ...i,
      }))
      .sort((a: QuestionTypeData, b: QuestionTypeData) => Number(a.sortOrder ?? 0) - Number(b.sortOrder ?? 0));
    const node = {
      key: item.id,
      title: item.questionTypeName,
      children,
      level: 1,
      ...item,
    };
    return node;
  });

  return treeData;
};

//Cây thư mục của danh mục loại câu hỏi chỉ dùng 2 cấp
const getSchoolTypeFromLoggedInUser = (loggedInUser: any): SchoolType | '' => {
  const schoolType = schoolTypeCodeOption.find((i) => i.schoolTypeId === loggedInUser?.schoolTypeId);
  return schoolType?.value ?? '';
};

export { buildTreeData_QuestionType, getSchoolTypeFromLoggedInUser };
